import React, { Component, PropTypes } from 'react';
import classNames from 'classnames';
import ComponentTitle from '../shared/ComponentTitle';
import Image from 'components/Image';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

const alignmentOptions = {
  top: 'top',
  left: 'left',
  bottom: 'bottom',
  right: 'right'
};

class ImageLink extends Component {

  static propTypes = {
    title: PropTypes.string,
    imageTitleAlignment: PropTypes.oneOf(Object.keys(alignmentOptions)),
    titleColor: PropTypes.string,
    width: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    height: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    staticUri: PropTypes.string,
    altText: PropTypes.string,
    destinationUri: PropTypes.string,
    target: PropTypes.string,
    titleType: PropTypes.string
  }

  static defaultProps = {
    target: '_blank',
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  render() {
    const {
      title,
      imageTitleAlignment = '',
      titleColor,
      width: imageWidth = 'auto',
      height: imageHeight = 'auto',
      staticUri,
      altText,
      destinationUri,
      target,
      titleType
    } = this.props;

    const titleAlignment = imageTitleAlignment.toLowerCase();

    const imageClass = classNames(
      'ImageLink-image',
      'ImageLink-image-title',
      {
        'ImageLink-image--verticalAlignCenter': titleAlignment === alignmentOptions.right || titleAlignment === alignmentOptions.left
      },
      {
        'ImageLink-image-title--alignRight': titleAlignment === alignmentOptions.right
      }
    );

    const components = [];
    
    const imageHref = destinationUri ? (
        <a href={destinationUri} target={target}>
          <Image src={staticUri} alt={altText} width={imageWidth} height={imageHeight} />
        </a>
      ) : (
        <Image src={staticUri} alt={altText} width={imageWidth} height={imageHeight} />
      );
    

    const componentImage = (
      <div key={components.length} className={classNames({'ImageLink-image--verticalAlignCenter': titleAlignment === alignmentOptions.right || titleAlignment === alignmentOptions.left})}>
          {imageHref}
      </div>
    );

    components.push(componentImage);

    if (alignmentOptions[titleAlignment] && title) {
      const componentTitle = (
        <div key={components.length} className={imageClass}>
          <ComponentTitle titleType={titleType} color={titleColor} title={title} link={destinationUri} target={target}/>
        </div>
      );

      if (titleAlignment === alignmentOptions.top || titleAlignment === alignmentOptions.left) {
        components.unshift(componentTitle);
      } else {
        components.push(componentTitle);
      }
    }

    return (
      <div className="ImageLink">
        {components}
      </div>
    );
  }
}

export default ImageLink;



// WEBPACK FOOTER //
// ./app/components/shared/ImageLink.js